import React, { memo } from "react";
import PropTypes from "prop-types";
import TimePicker from "react-time-picker";
import classNames from "classnames";

import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";

const TimePickerComponent = ({
  selectedTime,
  onChange,
  format,
  placeholder,
  disabled,
  className,
}) => {
  return (
    <div className={classNames("time-picker-wrapper", className)}>
      <TimePicker
        value={selectedTime || ""}
        onChange={onChange}
        format={format}
        disableClock
        disabled={disabled}
        clockIcon={null} // Hides the clock icon
        clearIcon={null} // Removes the clear button
        placeholder={placeholder}
      />
    </div>
  );
};

// **Prop Types**
TimePickerComponent.propTypes = {
  selectedTime: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  format: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

// **Default Props**
TimePickerComponent.defaultProps = {
  selectedTime: "",
  format: "HH:mm", // 24-hour format
  placeholder: "Select time",
  disabled: false,
  className: "form-control",
};

export default memo(TimePickerComponent);
